 <router-outlet (activate)="onChangeRouter()" ></router-outlet>
<ngx-ui-loader fgsSize="75" [fgsType]="SPINNER" fgsColor="#DD015B"></ngx-ui-loader>